<template>
    <header>
        <Icon data-action="navigation" type="md-menu" size="24" color="#009edb" @click.stop="toggleSidebar"/>
        <a class="nav-logo" href="/">
            <img src="static/nav-logo-blue.png" style="height: 28px;"/>
        </a>
        <div data-bar="navigation" class="d-flex justify-start">
            <div class="nav" v-for="(item, index) in $common.config.navigation" :key="index">
                <a class="link" :class="{active: active === index + 1}" @click.stop="onItem(item, index)">{{ language.key === 'cn' ? item.cnName : item.enName }}</a>
                <div class="group animated fadeInUp" v-if="item.children && item.children.length > 0">
                    <a class="item" v-for="(child, keying) in item.children" :key="keying" @click.stop="onItem(child, index)">{{ child.name }}</a>
                </div>
            </div>
            <a class="out-link" target="_blank" href="https://vt.anysonus.com:9999/login" v-if="false">{{ language.key === 'cn' ? '控制面板' : 'Control' }}</a>
        </div>
        <div class="d-flex justify-start">
            <Dropdown placement="bottom-end" trigger="hover">
                <a class="d-flex justify-start">
                    <img :src="language.icon"/>
                    <span language class="plr-xs">{{ language.name }}</span>
                    <Icon language-arrow type="ios-arrow-down"/>
                </a>
                <DropdownMenu slot="list">
                    <DropdownItem v-for="(item, index) in $common.config.language" :key="index" @click.native="toggleLanguage(item, index)">
                        <a class="d-flex justify-start">
                            <img :src="item.icon"/>
                            <span class="pl-xs">{{ item.name }}</span>
                        </a>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
            <span class="plr-ns"/>
            <Avatar class="avatar" icon="md-person" size="24" v-if="!$store.state.account" @click.native="toggleContact(0)"/>
            <Dropdown placement="bottom-end" trigger="click" v-if="$store.state.account">
                <a class="d-flex justify-start">
                    <Avatar icon="md-person" size="24"/>
                    <span user class="plr-xs">{{ $store.state.account.name }}</span>
                    <Icon user-arrow type="ios-arrow-down"/>
                </a>
                <DropdownMenu slot="list">
                    <DropdownItem divided v-if="false">
                        <a class="d-flex justify-start">
                            <Icon type="md-arrow-down" size="18"/>
                            <span class="pl-xs">下载记录</span>
                        </a>
                    </DropdownItem>
                    <DropdownItem @click.native="loginOut">
                        <a class="d-flex justify-start c-error">
                            <Icon type="md-log-out" size="18"/>
                            <span class="pl-xs">{{ language.key === 'cn' ? '退出登录' : 'Logout' }}</span>
                        </a>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </div>
    </header>
</template>

<style scoped>
    .avatar:hover{cursor: pointer; opacity: .9;}
</style>

<script type="text/javascript">
    export default {
        data() {
            return {
                active: 1,

                language: {},
            }
        },
        async created() {
            let lang = localStorage.getItem('lang');
            this.language = {} = await this.$common.config.language.find(it => it.key === lang);
            console.log('------', this.language);
        },
        methods: {
            toggleContact(type){
                console.log('this.toggleContact---------->', type);
                this.$bus.emit('toggleContact', true, type);
            },
            toggleSidebar(){
                this.$bus.emit('toggleSidebar', true);
            },
            onItem(data, i){
                console.log('this.onItem---------->', data, i);
                this.active = i + 1;

                if (!data.path) return;

                if (data.path === '/product'){
                    this.$router.push({
                        path: data.path,
                        query: {
                            id: data.id
                        }
                    });
                    this.$bus.emit('initProduct', true);
                } else if (data.path === '/solution'){
                    this.$router.push({
                        path: data.path,
                        query: {
                            id: data.id,
                            model: 'solution',
                        }
                    });
                    this.$bus.emit('loadSolution', true);
                } else {
                    this.$router.push({
                        path: data.path,
                    });
                }
            },
            toggleLanguage(data, i){
                console.log('this.toggleLanguage---------->', data, i);
                this.language = {} = data;
                localStorage.setItem('lang', data.key);
                window.location.href = '/';
            },
            loginOut(){
                localStorage.clear();
                window.location.reload();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue